import { render, staticRenderFns } from "./queueTasks.vue?vue&type=template&id=3798deb0&scoped=true&"
import script from "./queueTasks.vue?vue&type=script&lang=js&"
export * from "./queueTasks.vue?vue&type=script&lang=js&"
import style0 from "./queueTasks.vue?vue&type=style&index=0&id=3798deb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3798deb0",
  null
  
)

export default component.exports